module.exports = "/_next/static/images/icon_44-26a77adf65b717c179eaf45767432dca.png";